import React from 'react'
import { IconProps } from '../../../common/types' // Optional: only if you're using props like size or color

const CalenderGreenIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
    >
      <path
        d="M8.83333 18.485L4.88889 14.58L6.5 12.985L8.83333 15.295L13.5 10.675L15.1111 12.27L8.83333 18.485ZM2.22222 22.5C1.61111 22.5 1.08815 22.2848 0.653333 21.8543C0.218519 21.4238 0.000740741 20.9057 0 20.3V4.9C0 4.295 0.217778 3.77727 0.653333 3.3468C1.08889 2.91633 1.61185 2.70073 2.22222 2.7H3.33333V0.5H5.55556V2.7H14.4444V0.5H16.6667V2.7H17.7778C18.3889 2.7 18.9122 2.9156 19.3478 3.3468C19.7833 3.778 20.0007 4.29573 20 4.9V20.3C20 20.905 19.7826 21.4231 19.3478 21.8543C18.913 22.2855 18.3896 22.5007 17.7778 22.5H2.22222ZM2.22222 20.3H17.7778V9.3H2.22222V20.3Z"
        fill="#03B903"
      />
    </svg>
  )
}

export default CalenderGreenIcon
